module.exports = __webpack_public_path__ + "/images/shop/icon/payment_in_advance.svg";